import Keycloak from 'keycloak-js';
import {
	createContext,
	PropsWithChildren,
	useContext,
	useEffect,
	useState,
} from 'react';

type TKeycloakContext = {
	keycloak: Keycloak | undefined;
	isInitialized: boolean;
};

const KeycloakContext = createContext<TKeycloakContext | undefined>(undefined);

export const KeycloakProvider: React.FC<PropsWithChildren> = ({ children }) => {
	const [keycloak, setKeycloak] = useState<Keycloak | undefined>();
	const [isInitialized, setIsInitialized] = useState(false);

	useEffect(() => {
		const keycloak = new Keycloak({
			url: process.env.REACT_APP_KEYCLOAK_URL!,
			realm: process.env.REACT_APP_KEYCLOAK_REALM!,
			clientId: process.env.REACT_APP_KEYCLOAK_CLIENT_ID!,
		});
		keycloak.init({ onLoad: 'login-required' }).then((authenticated) => {
			if (authenticated) {
				localStorage.setItem('token', keycloak.token!);
				localStorage.setItem('refresh_token', keycloak.refreshToken!);
			}
			setKeycloak(keycloak);
			setIsInitialized(true);
		});
	}, []);

	return (
		<KeycloakContext.Provider value={{ keycloak, isInitialized }}>
			{children}
		</KeycloakContext.Provider>
	);
};

export const useKeycloak = () => {
	const context = useContext(KeycloakContext);
	if (context === undefined) {
		throw new Error('useKeycloak must be used within a AuthProvider');
	}
	return context;
};
